export default {
  items: [
    {
      name: "Portafolio",
      url: "/",
      iconUrl: "../svg/SideBarIcons/portafolio.svg",
    },
    {
      name: "Histórico",
      url: "/history",
      iconUrl: "../svg/SideBarIcons/historico.svg",
    },
    {
      name: "Ingresos futuros",
      url: "/futureIncome",
      iconUrl: "../svg/SideBarIcons/ingresosFuturos.svg",
    },
    {
      name: "Reportes mensuales",
      url: "/calendar",
      iconUrl: "../svg/SideBarIcons/estadosMensuales.svg",
    },
    {
      name: "Órdenes en proceso",
      url: "/orders",
      iconUrl: "../svg/SideBarIcons/ordenes.svg",
      counter: "inProcessOrders",
    },
    {
      name: "Autorizaciones",
      url: "/authorizations",
      iconUrl: "../svg/SideBarIcons/autorizaciones.svg",
    },
    {
      name: "Invertir",
      url: "/invest",
      iconUrl: "../svg/SideBarIcons/invertir.svg",
    },

    // {
    //   name: "Notificaciones",
    //   url: "/notifications",
    //   iconUrl: "../svg/notificaciones.svg",
    //   counter: "notifications",
    // },
    // {
    //   name: "Documentación",
    //   url: "/documentation",
    //   iconUrl: "../svg/documentacion.svg",
    // },
    // {
    //   name: "Ayuda",
    //   url: "/help",
    //   iconUrl: "../svg/help.svg",
    // },
    // {
    //   name: "Cerrar sesión",
    //   url: "/login",
    //   iconUrl: "../svg/logout.svg",
    // },
  ],
};
